export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11655.638a328c.jpg";